import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UxService } from '~/app/core/services';
import { AppointmentDetailBaseComponent } from '~/app/open-age/welcome/components/appointment-detail-base.component';
import { AppointmentsService } from '~/app/open-age/welcome/services';
import { RoleService } from '~/app/open-age/core/services';
import { MatDialog } from '@angular/material';
import { User } from '~/app/open-age/welcome/models/user.model';
import { QuickAddPatientsDialogComponent } from '../dialog/quick-add-patients-dialog/quick-add-patients-dialog.component';
import { ConfirmDialogComponent } from '~/app/core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'welcome-appointment-details',
  templateUrl: './appointment-details.component.html',
  styleUrls: ['./appointment-details.component.css']
})
export class AppointmentDetailsComponent extends AppointmentDetailBaseComponent {

  constructor(
    service: AppointmentsService,
    uxService: UxService,
    private auth: RoleService,
    public dialog: MatDialog,
  ) {
    super(service, uxService, dialog);
  }

  copyItemValue(item) {
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (item));
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
  }

  download(offset: number, timezone: string) {
    let url
    let tenant = this.auth.currentTenant()
    for (const service of tenant.services) {
      if (service.code == "drive") {
        url = service.url
      }
    }
    if (this.properties.status == 'expired' || this.properties.status == 'visited') {
      url = url + `/docs/appointment-details-past/${this.properties.id}.pdf?access_token=${this.auth.currentRole().token}&offset=${offset}&timezone=${timezone}`
    } else {
      url = url + `/docs/appointment-details/${this.properties.id}.pdf?access_token=${this.auth.currentRole().token}&offset=${offset}&timezone=${timezone}`
    }
    window.open(url, "_blank")
  }

  quickAddUser() {
    const dialogRef = this.dialog.open(QuickAddPatientsDialogComponent);
    dialogRef.afterClosed().subscribe((data) => {
      if (data && data.isSuccess) {
        if (data.patient) {
          let visitors = []
          for (const visitor of this.properties.visitors) {
            visitors.push(visitor)
          }
          this.properties.visitors = []
          let exists = false
          for (const visitor of visitors) {
            if (visitor.user.role.id == data.patient.role.id) {
              exists = true
            }
          }
          if (!exists) {
            let meta = {
              division: data.patient.practiceLocation,
              providers: data.patient.practitioners,
              organization: data.patient.practice
            }
            let newUser = new User({
              role: data.patient.role,
              profile: data.patient.profile,
              meta: meta,
            })
            if (data.patient.profile && data.patient.profile.middleName) {
              newUser.profile.lastName = data.patient.profile.middleName + " " + newUser.profile.lastName
            }
            if (data.patient.profile && data.patient.profile.prefix) {
              newUser.profile.title = data.patient.profile.prefix
            }
            visitors.push({
              user: newUser, attandance: {
                status: "Absent"
              }
            })
            this.isChanged = true
          }
          this.properties.visitors = visitors
        }
      }
    });
  }

  removePatient(patient: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '450px',
    });
    dialogRef.componentInstance.message = `Do you want to remove ${patient.user.profile.firstName} ${patient.user.profile.lastName} ?`
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let arr = []
        for (const visitor of this.properties.visitors) {
          if (visitor.user.role.id != patient.user.role.id) {
            arr.push(visitor)
          }
        }
        this.isChanged = true
        this.properties.visitors = arr;
      }
    })
  }

}
